import { Col, Row } from "antd";
import classnames from "classnames";
import _ from "lodash";
import React from "react";
import { useSelector } from "react-redux";
import { IStorageState } from "../../reducers/authState/authReducer";
import { IState } from "../../store/rootReducer";
import HeaderRight from "./header-right";
import NotifiCation from "./notification";
import "./style.less";

const Header = () => {
  const isCollapsed = useSelector((state: IState) => state.global.isCollapsed);
  const user = useSelector(({ auth }: { auth: IStorageState }) => auth.user);
  const branch = _.get(user, "branch");

  return (
    <div className={classnames("header-wrap", { collapsed: isCollapsed })}>
      <Col span={24} className="header-right">
        <Row justify="end">
          <p>{`CHI NHÁNH ${branch.substr(branch.length - 1)}`}</p>
          <NotifiCation />
          <HeaderRight />
        </Row>
      </Col>
    </div>
  );
};

export default Header;
